import { formatMoney } from 'client-portal/helpers/format-money';
import Model, { attr } from '@ember-data/model';

export default class AppointmentBillingTimelineEntryModel extends Model {
  @attr('moment') entryDate;
  @attr() entryType;
  @attr('number') trackedValue;
  @attr('number') trackedValueDelta;
  @attr('json') metadata;

  get entryDescription() {
    switch (this.entryType) {
      case 'fee_updated':
      case 'write_off_updated':
      case 'client_responsibility_updated':
        return this._amountUpdateDescription();
      case 'appointment_type_updated':
        return `Appointment type changed to ${this._appointmentType()}`;
      case 'invoice_credit_applied':
        return `Applied credit of ${this._entryAmountDelta()}`;
      case 'client_payment_created':
      case 'client_payment_refunded':
      case 'client_payment_disputed':
      case 'client_payment_deleted':
        return this._clientPaymentDescription();
      case 'unallocated_from_invoice':
        return `Account credit for ${this._entryAmountDelta()}`;
      case 'refund_deleted':
        return `Deleted refund of ${this._entryAmountDelta()}`;
      case 'dispute_won':
        return 'Dispute resolved in your favor';
      case 'insurance_payment_created':
      case 'insurance_payment_edited':
      case 'insurance_payment_deleted':
        return this._insuranceEntryDescription();
      default:
        return this._defaultEntryDescription();
    }
  }

  _amountUpdateDescription() {
    let attr = '';
    switch (this.entryType) {
      case 'fee_updated':
        attr = 'Total fee';
        break;
      case 'write_off_updated':
        attr = 'Write-off';
        break;
      case 'client_responsibility_updated':
        attr = 'Your responsibility';
        break;
    }
    return `${attr} ${this._entryChange()} to ${this._entryAmount()}`;
  }

  _clientPaymentDescription() {
    if (this.entryType === 'client_payment_deleted')
      return `Deleted payment of ${this._entryAmountDelta()}`;

    let type = '';
    switch (this.entryType) {
      case 'client_payment_created':
        type = 'Payment';
        break;
      case 'client_payment_refunded':
        type = 'Refund';
        break;
      case 'client_payment_disputed':
        type = 'Dispute';
        break;
    }

    return `${type} for ${this._entryAmountDelta()}`;
  }

  _insuranceEntryDescription() {
    let action = '';
    switch (this.entryType) {
      case 'insurance_payment_created':
        action = 'for';
        break;
      case 'insurance_payment_edited':
        action = 'edited';
        break;
      case 'insurance_payment_deleted':
        action = 'deleted';
        break;
    }
    return `Insurance payment ${action} ${this._entryAmountDelta()}`;
  }

  _defaultEntryDescription() {
    if (this.trackedValue !== null) {
      return `${this.entryType} ${this._entryAmount()}`;
    } else {
      return this.entryType;
    }
  }

  _entryChange() {
    return this.trackedValueDelta > 0 ? 'increased' : 'decreased';
  }

  _entryAmount() {
    return formatMoney([this.trackedValue], { format: 'stripeFormat' });
  }

  _entryAmountDelta() {
    return formatMoney([this.trackedValueDelta], { format: 'stripeFormat' });
  }

  _appointmentType() {
    return this.metadata.billingType === 0 ? 'self-pay' : 'insurance';
  }
}
